module.exports = __webpack_public_path__ + "static/media/feature_flag_main_visual_mobile_en.4953565d.png";